import { FaListUl, FaNotesMedical, FaXRay, FaFolderOpen } from 'react-icons/fa'
import { LuTestTubeDiagonal } from 'react-icons/lu'
import { MdMedication, MdOutlineReportProblem } from 'react-icons/md'
import ProgressNotes from '../pages/patient-profile/ProgressNotes'
import HistoryPhysicalNotes from '../pages/patient-profile/HistoryPhysicalNotes'
import ConsultNote from '../pages/patient-profile/ConsultNote'
import ProcedureNote from '../pages/patient-profile/ProcedureNote'
import NursingNote from '../pages/patient-profile/NursingNote'
import { sequenceTableTemplate } from '../utils/squenceTableNo'
import { formatDateTime } from '../utils/FormateDateTime'
import { extractTextFromHTML } from '../utils/ExtractTextFromHtml'

export const procedureNotesColumns = t => [
  {
    body: sequenceTableTemplate,
    header: t('No.'),
    style: { width: '3rem' }
  },
   {
    body: row => formatDateTime(row?.createdAt),
    header: t('Created Date'),
    style: { width: '10rem' },
    bodyCellClass: '!whitespace-pre-wrap'
  },

  {
    field: 'practitioner_name',
    header: `${t('Practitioner')} ${t('Name')}`
  },
  {
    body: rowData => extractTextFromHTML(rowData?.progress_notes),
    header: t('notes')
  }
]

export const links = (t) => [
    {
        id: 1,
        label: t('Allergies'),
        icon: <MdOutlineReportProblem className="text-[12px]" />,
        link: '/his/patient-profile/allergies',
        moduleName: 'profile',
        permission: 'view',
    },
    {
        id: 2,
        label: t('Medical History'),
        icon: <FaListUl className="text-[12px]" />,
        link: '/his/patient-profile/emr',
        moduleName: 'profile',
        permission: 'view',
    },
      {
        id: 3,
        label: t('Doctor Notes'),
        icon: <FaNotesMedical className="text-[12px]" />,
        link: '/his/patient-profile/doctor-notes',
        moduleName: 'profile',
        permission: 'view',
    },
       {
        id: 4,
        label: t('Lab Orders'),
        icon: <LuTestTubeDiagonal className="text-[12px]" />,
        link: '/his/patient-profile/lab/orders-list',
        moduleName: 'history',
        permission: 'view',
    },
       {
        id: 5,
        label: t('Radiology Orders'),
        icon: <FaXRay className="text-[12px]" />,
        link: '/his/patient-profile/radiology/orders-list',
        moduleName: 'history',
        permission: 'view',
    },
       {
        id: 6,
        label: t('Pharmacy Orders'),
        icon: <MdMedication className="text-[12px]" />,
        link: '/his/patient-profile/pharmacy/orders-list',
        moduleName: 'history',
        permission: 'view',
    },
    {
        id: 7,
        label: t('Manual Lab Results'),
        icon: <FaFolderOpen className="text-[12px]" />,
        link: '/his/patient-profile/manual-lab-results',
        moduleName: 'result',
        permission: 'view',
    },
    {
        id: 8,
        label: t('Manual Radiology Results'),
        icon: <FaFolderOpen className="text-[12px]" />,
        link: '/his/patient-profile/manual-radiology-results',
        moduleName: 'result',
        permission: 'view',
    },
    //    {
    //     id: 5,
    //     label: t('Orders Tracking'),
    //     icon: <LuTestTubeDiagonal className="text-[12px]" />,
    //     link: '/his/patient-profile/orders-tracking',
    //     moduleName: 'history',
    //     permission: 'view',
    // },

   
]



export const doctorNotesTabs = t => [
  { name: t('progress_notes'), content: <ProgressNotes /> },
  { name: t('history_and_physical'), content: <HistoryPhysicalNotes /> },
  { name: t('consult_notes'), content: <ConsultNote /> },
  { name: t('procedure_notes'), content: <ProcedureNote /> },
  { name: t('nursing_notes'), content: <NursingNote /> }
]

export const consultationRequestsColumns = t => [
  {
    body: sequenceTableTemplate,
    header: t('No.'),
    style: { width: '3rem' }
  },
  {
    body: row => formatDateTime(row?.createdAt),
    header: t('Created Date'),
    style: { width: '10rem' },
    bodyCellClass: '!whitespace-pre-wrap'
  },

  {
    field: 'practitioner_name',
    header: `${t('Practitioner')} ${t('Name')}`
  },
  {
    body: rowData => extractTextFromHTML(rowData?.progress_notes),
    header: t('notes')
  }
]

export const historyAndPhysicalNotesColumns = t => [
  {
    body: sequenceTableTemplate,
    header: t('No.'),
    style: { width: '3rem' }
  },
   {
    body: row => formatDateTime(row?.createdAt),
    header: t('Created Date'),
    style: { width: '10rem' },
    bodyCellClass: '!whitespace-pre-wrap'
  },

  {
    field: 'practitioner_name',
    header: `${t('Practitioner')} ${t('Name')}`
  },
  {
    body: rowData => extractTextFromHTML(rowData?.progress_notes),
    header: t('notes')
  }
]
export const NursingNotesColumns = t => [
  {
    body: sequenceTableTemplate,
    header: t('No.'),
    style: { width: '3rem' }
  },
   {
    body: row => formatDateTime(row?.createdAt),
    header: t('Created Date'),
    style: { width: '10rem' },
    bodyCellClass: '!whitespace-pre-wrap'
  },

  {
    field: 'practitioner_name',
    header: `${t('Practitioner')} ${t('Name')}`
  },
  {
    body: rowData => extractTextFromHTML(rowData?.progress_notes),
    header: t('notes')
  }
]

export const progressNotesTableColumns = t => [
  {
    body: sequenceTableTemplate,
    header: t('No.'),
    style: { width: '3rem' },
    bodyCellClass: '!whitespace-pre-wrap'
  },
  {
    field: 'createdAt',
    body: row => formatDateTime(row?.createdAt),
    header: t('Created Date'),
    style: { width: '10rem' },
    bodyCellClass: '!whitespace-pre-wrap'
  },

  {
    field: 'practitioner_name',
    header: `${t('Practitioner')} ${t('Name')}`,
    style: { width: '10rem' },
    bodyCellClass: '!whitespace-pre-wrap'
  },

  {
    body: rowData => extractTextFromHTML(rowData?.progress_notes),
    header: t('notes'),
    bodyCellClass: '!whitespace-pre-wrap'
  }
]
